import { siteState } from '@/modules/siteState/siteStateGetter';

import { commonController } from '@/controllers/commonController';
import { homeController } from '@/controllers/homeController';

commonController.init();

const pageControllers = [
  {
    page: 'home',
    init: () => homeController.init(),
  },
  // {
  //   page: 'about',
  //   init: () => about.init(),
  // },
];

const dataPage = siteState.dataPage;

if (dataPage) {
  const controller = pageControllers.find((item) => item.page === dataPage);
  controller?.init();
}
